export default __webpack_public_path__ + "static/media/2166.a4772fdd.png";